(function () {
  'use strict';

  var scheduled = false;
  var applying = false;

  // Symbols that belong to non-USD dollar currencies — if text contains ONLY
  // these (and not US$ / USD / bare $) it is already in the local currency.
  var LOCAL_DOLLAR_SYMBOLS = ['A$', 'CA$', 'NZ$', 'HK$', 'S$'];

  function getDrawer() {
    return document.getElementById('CartDrawer');
  }

  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function getActiveCurrency() {
    return (
      window.Shopify &&
      window.Shopify.currency &&
      window.Shopify.currency.active
    ) || (
      document.querySelector('meta[property="og:price:currency"]') &&
      document.querySelector('meta[property="og:price:currency"]').content
    ) || 'USD';
  }

  function getCurrencyRate() {
    var rate = Number(
      window.Shopify &&
      window.Shopify.currency &&
      window.Shopify.currency.rate || 0
    );

    return rate > 0 ? rate : 1;
  }

  function parseMoneyToCents(text) {
    if (!text) return 0;

    var clean = String(text).replace(/[^\d.,]/g, '');
    if (!clean) return 0;

    var lastComma = clean.lastIndexOf(',');
    var lastDot   = clean.lastIndexOf('.');
    var decimalIndex = Math.max(lastComma, lastDot);

    if (decimalIndex === -1) {
      return Number(clean.replace(/\D/g, '')) * 100;
    }

    var decimals = clean.slice(decimalIndex + 1);
    var whole    = clean.slice(0, decimalIndex).replace(/\D/g, '');

    if (decimals.length !== 2) {
      return Number(clean.replace(/\D/g, '')) * 100;
    }

    return Number(whole + decimals);
  }

  function formatMoney(cents, currency) {
    var amount = Number(cents || 0) / 100;
    var locale = document.documentElement.lang || navigator.language || 'en-US';

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency || 'USD'
      }).format(amount);
    } catch (_) {
      return (currency || 'USD') + ' ' + amount.toFixed(2);
    }
  }

  /**
   * Returns true only when the text contains a USD-style price that still
   * needs to be converted.  Texts that are already in the local currency
   * (e.g. "A$93.00" when currency === "AUD") are treated as already done.
   */
  function shouldPatchText(text, currency) {
    if (!text || currency === 'USD') return false;

    var str = String(text);

    // Explicit USD markers always need patching
    if (str.indexOf('USD') > -1 || str.indexOf('US$') > -1) return true;

    // Bare "$" present — but make sure it isn't actually a local-dollar symbol
    if (str.indexOf('$') > -1) {
      // If every "$" occurrence is preceded by a local prefix, it's already
      // in the local currency — no need to patch again.
      for (var i = 0; i < LOCAL_DOLLAR_SYMBOLS.length; i++) {
        if (str.indexOf(LOCAL_DOLLAR_SYMBOLS[i]) > -1) {
          // The only dollar sign comes from a local symbol → already converted
          var withoutLocal = str.split(LOCAL_DOLLAR_SYMBOLS[i]).join('');
          if (withoutLocal.indexOf('$') === -1) {
            return false;
          }
        }
      }
      return true;
    }

    return false;
  }

  function patchText(text, currency) {
    if (!shouldPatchText(text, currency)) return text;

    return String(text).replace(/(?:US\$|USD|\$)\s*[\d][\d,.]*/g, function (match) {
      var cents = parseMoneyToCents(match);
      if (!cents) return match;

      return formatMoney(cents, currency);
    });
  }

  function patchTextNodes(root, currency) {
    if (!root) return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var nodes  = [];
    var node;

    while ((node = walker.nextNode())) {
      nodes.push(node);
    }

    nodes.forEach(function (textNode) {
      var current = textNode.nodeValue;
      var next    = patchText(current, currency);

      if (next !== current) {
        textNode.nodeValue = next;
      }
    });
  }

  function patchUpsellPrices(currency) {
    var drawer = getDrawer();
    if (!drawer) return;

    var rate = currency === 'USD' ? 1 : getCurrencyRate();

    qsa('#cd-upsell .cd-up-price', drawer).forEach(function (el) {
      if (el.dataset.marketCurrency === currency) return;

      var baseCents = Number(el.dataset.baseCents || 0);
      var compareCents = Number(el.dataset.compareCents || 0);

      if (!baseCents) {
        var text = el.textContent || '';
        if (!shouldPatchText(text, currency)) return;
        baseCents = parseMoneyToCents(text);
      }

      if (!baseCents) return;

      var convertedCents = Math.round(baseCents * rate);
      var convertedCompareCents = compareCents > baseCents ? Math.round(compareCents * rate) : 0;

      if (!isFinite(convertedCents) || convertedCents <= 0) return;

      var html = '<span class="money">' + formatMoney(convertedCents, currency) + '</span>';

      if (convertedCompareCents > convertedCents && isFinite(convertedCompareCents)) {
        html += '<s style="font-size:11px;color:var(--cdmuted);margin-left:3px">' + formatMoney(convertedCompareCents, currency) + '</s>';
      }

      el.innerHTML = html;
      el.dataset.marketCurrency = currency;
    });
  }

  function patchCartDrawerMoney() {
    var drawer = getDrawer();
    if (!drawer || applying) return;

    applying = true;

    var currency = getActiveCurrency();

    qsa('.cd-p-was, [data-subtotal-compare], .cd-pp-name', drawer).forEach(function (el) {
      patchTextNodes(el, currency);
    });

    patchUpsellPrices(currency);

    applying = false;
  }

  function schedulePatch() {
    if (scheduled) return;

    scheduled = true;

    requestAnimationFrame(function () {
      scheduled = false;
      patchCartDrawerMoney();
    });
  }

  function runPatchBurst() {
    schedulePatch();

    setTimeout(schedulePatch, 120);
    setTimeout(schedulePatch, 350);
    setTimeout(schedulePatch, 700);
    setTimeout(schedulePatch, 1200);
  }

  document.addEventListener('cart:updated', runPatchBurst);
  document.addEventListener('cart:refresh', runPatchBurst);

  document.addEventListener('click', function (event) {
    if (
      event.target.closest(
        '[data-add-to-cart], [data-qty-change], [data-remove], [data-upsell-add], [data-up-add], [data-pp-toggle], .js-drawer-open-cart, [aria-controls="CartDrawer"]'
      )
    ) {
      runPatchBurst();
    }
  }, true);

  if (window.MutationObserver) {
    var drawer = getDrawer();

    if (drawer) {
      var observer = new MutationObserver(function () {
        if (applying) return;
        schedulePatch();
      });

      observer.observe(drawer, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runPatchBurst);
  } else {
    runPatchBurst();
  }

  window.CartMarketMoney = {
    refresh: patchCartDrawerMoney
  };
})();